<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="6" lg="7" md="9" cols="12">
            <v-stepper-vertical color="secondary" eager flat :items="steps" v-model="stepper">
                <template #item.1>
                    <v-form @submit.prevent="changeStep()" class="pt-2" ref="step1Form">
                        <switch-input v-model="form.status" label="وضعیت"></switch-input>
                        <v-radio-group inline v-model="form.gender">
                            <p class="text-meta text-primary mb-0">جنسیت:</p>
                            <v-radio :value="true" label="مرد"></v-radio>
                            <v-radio :value="false" label="زن"></v-radio>
                            <v-radio :value="null" label="نامشخص"></v-radio>
                        </v-radio-group>
                        <v-row dense>
                            <v-col sm="6" cols="12">
                                <v-text-field
                                    :rules="$validation('required')"
                                    label="* نام"
                                    v-model="form.first_name"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-col>
                            <v-col sm="6" cols="12">
                                <v-text-field
                                    :rules="$validation('required')"
                                    label="* نام خانوادگی"
                                    v-model="form.last_name"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-col>
                            <v-col sm="6" cols="12">
                                <v-text-field
                                    :rules="$validation([($system.systemSettings.username_type == 'username' ? 'required' : false), ($system.systemSettings.username_regex ? 'regex:' + $system.systemSettings.username_regex : false)].filter(Boolean))"
                                    :label="$system.systemSettings.username_type == 'username' ? '* نام کاربری' : 'نام کاربری'"
                                    :placeholder="$system.systemSettings.username_example"
                                    v-model="form.username"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-col>
                            <v-col sm="6" cols="12">
                                <datetime-input
                                    label="تاریخ تولد"
                                    type="date"
                                    clearable
                                    v-model="form.birthday"
                                ></datetime-input>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea
                                    :rules="$validation()"
                                    label="توضیحات"
                                    no-resize
                                    rows="2"
                                    v-model="form.customer_fields.description"
                                    autocomplete="new-password"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </template>
                <template #item.2>
                    <v-form @submit.prevent="changeStep()" class="pt-2" ref="step2Form">
                        <v-text-field
                            :rules="$validation('required:' + ($system.systemSettings.username_type == 'email'))"
                            :label="$system.systemSettings.username_type == 'email' ? '* ایمیل' : 'ایمیل'"
                            v-model="form.email"
                            autocomplete="new-password"
                        ></v-text-field>
                        <v-row dense>
                            <v-col cols="12" sm="5">
                                <v-text-field
                                    :rules="$validation('required:' + ($system.systemSettings.username_type == 'mobile'))"
                                    :label="$system.systemSettings.username_type == 'mobile' ? '* شماره موبایل' : 'شماره موبایل'"
                                    v-model="form.mobile"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="5">
                                <v-text-field
                                    :rules="$validation()"
                                    label="تلفن ثابت"
                                    v-model="form.landline"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-text-field
                                    :rules="$validation()"
                                    label="داخلی"
                                    v-model="form.interphone"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-combobox
                            :items="form.ohter_phones"
                            label="سایر تلفن ها"
                            chips
                            closable-chips
                            hide-selected
                            multiple
                            autocomplete="new-password"
                            v-model="form.other_phones"
                        ></v-combobox>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-autocomplete
                                    :items="$system.countries"
                                    @update:modelValue="form.customer_fields.state_id = null; form.customer_fields.city_id = null"
                                    clearable
                                    item-title="name"
                                    item-value="id"
                                    label="کشور"
                                    no-data-text="موردی پیدا نشد!"
                                    v-model="form.customer_fields.country_id"
                                    autocomplete="new-password"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete
                                    :disabled="form.customer_fields.country_id ? false : true"
                                    :items="$system.states.filter(x=> x.country_id == form.customer_fields.country_id)"
                                    @update:modelValue="form.customer_fields.city_id = null"
                                    clearable
                                    item-title="name"
                                    item-value="id"
                                    label="استان"
                                    no-data-text="موردی پیدا نشد!"
                                    v-model="form.customer_fields.state_id"
                                    autocomplete="new-password"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete
                                    :disabled="form.customer_fields.state_id ? false : true"
                                    :items="$system.cities.filter(x=> x.state_id == form.customer_fields.state_id)"
                                    clearable
                                    item-title="name"
                                    item-value="id"
                                    label="شهر"
                                    no-data-text="موردی پیدا نشد!"
                                    v-model="form.customer_fields.city_id"
                                    autocomplete="new-password"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-textarea
                            :rules="$validation()"
                            label="آدرس"
                            no-resize
                            rows="2"
                            v-model="form.address"
                            autocomplete="new-password"
                        ></v-textarea>
                    </v-form>
                </template>
                <template v-if="haveCustomField" #item.3>
                    <v-form @submit.prevent="changeStep()" class="pt-2" ref="step3Form">
                        <custom-fields-form v-model="form.customer_fields.custom_fields" :items="customFieldItems"></custom-fields-form>
                    </v-form>
                </template>
                <template #[`item.${3+haveCustomField}`]>
                    <v-form @submit.prevent="changeStep()" class="pt-2" :ref="`step${3+haveCustomField}Form`">
                        <p class="text-small text-grey-darken-1 mb-2 mt-2">چنانچه قصد تغییر کلمه عبور قبلی را ندارید از تکمیل گزینه‌های زیر خودداری کنید. <br><span v-if="$system.systemSettings.force_users_using_secure_password">(کلمه عبور می‌باید دارای حداقل 8 کاراکتر شامل حروف کوچک و بزرگ انگلیسی، اعداد و علامت‌های خاص باشد.).</span></p>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    :rules="$validation([$system.systemSettings.force_users_using_secure_password ? 'complex' : false].filter(Boolean))"
                                    :append-inner-icon="pass1 ? 'visibility' : 'visibility_off'"
                                    :type="pass1 ? 'password' : 'text'"
                                    @click:appendInner="() => {pass1 = !pass1}"
                                    label="کلمه عبور"
                                    v-model="form.password"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    :rules="$validation([$system.systemSettings.force_users_using_secure_password ? 'complex' : false].filter(Boolean))"
                                    :append-inner-icon="pass2 ? 'visibility' : 'visibility_off'"
                                    :type="pass2 ? 'password' : 'text'"
                                    @click:appendInner="() => {pass2 = !pass2}"
                                    label="تکرار کلمه عبور"
                                    v-model="form.password_confirmation"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </template>
                <template #[`item.${4+haveCustomField}`]>
                    <v-form @submit.prevent="validate() && submit()" class="pt-2" :ref="`step${4+haveCustomField}Form`">
                        <v-autocomplete
                            :rules="$validation('required')"
                            :items="$system.branches"
                            v-if="$auth.user.full_admin"
                            class="mb-2"
                            item-title="name"
                            item-value="id"
                            label="* انتخاب شعبه"
                            no-data-text="موردی پیدا نشد!"
                            v-model="form.branch_id"
                            :disabled="!form.change_branch"
                            @update:modelValue="(value) => { organizations = $system.organizations.filter(x => x.branch_id == value); form.customer_fields.organization_id = null }"
                            autocomplete="new-password"
                        ></v-autocomplete>
                        <v-row dense>
                            <v-col>
                                <v-autocomplete
                                    :rules="$validation('required')"
                                    :items="organizations"
                                    :disabled="$auth.user.full_admin && !form.branch_id"
                                    @update:modelValue="setCustomerLevel"
                                    class="mb-2"
                                    item-title="name"
                                    item-value="id"
                                    label="* سازمان مشتری"
                                    no-data-text="موردی پیدا نشد!"
                                    v-model="form.customer_fields.organization_id"
                                    autocomplete="new-password"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="auto" class="mt-2" v-if="$rbac.can('manage organizations')">
                                <v-btn v-tooltip="'سازمان جدید'" icon="add" size="small" color="secondary" @click="addOrganizationDialog = true"></v-btn>
                            </v-col>
                        </v-row>
                        <v-autocomplete
                            :rules="$validation('required')"
                            :items="$system.customerLevels"
                            class="mb-2"
                            item-title="name"
                            item-value="id"
                            label="* سطح مشتری"
                            no-data-text="موردی پیدا نشد!"
                            v-model="form.customer_fields.customer_level_id"
                            autocomplete="new-password"
                        ></v-autocomplete>
                        <v-text-field
                            :rules="$validation()"
                            label="سمت سازمانی"
                            v-model="form.customer_fields.position"
                            autocomplete="new-password"
                        ></v-text-field>
                        <p class="text-small text-grey-darken-1 mb-4">تکمیل کردن این فیلد باعث می‌گردد پس از تاریخ انقضا دسترسی به سامانه برای مشتریان محدود گردد.</p>
                        <datetime-input
                            :min="maxAssignedExpireDate"
                            type="date"
                            label="تاریخ اتمام دسترسی"
                            clearable
                            v-model="form.customer_fields.expire_date"
                        ></datetime-input>
                        <v-row dense align="center">
                            <v-col cols="auto">
                                <v-checkbox
                                    :disabled="!form.customer_fields.organization_id"
                                    class="mt-0 pt-0"
                                    label="سرپرست سازمان"
                                    hide-details
                                    v-model="form.customer_fields.supervisor"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="auto">
                                <v-icon class="cursor-pointer ms-1" color="secondary" size="22" v-tooltip="'سرپرست سازمان علاوه بر تیکت های خود، امکان مشاهده تیکت های سایر همکاران مجموعه خود را نیز دارا خواهد بود'">info</v-icon>
                            </v-col>
                        </v-row>
                        <v-checkbox
                            class="mt-2 pt-0"
                            label="محدود کردن سازمان به دپارتمان"
                            hide-details
                            v-if="$system.license.features.customer_department"
                            v-model="assignedDepartmentCheck"
                            @update:modelValue="!form.customer_fields.assigned_departments.length ? form.customer_fields.assigned_departments.push({department_id: null, meta_data: {expired_at: null, limit: null}}) : null"
                        ></v-checkbox>
                        <div v-if="$system.license.features.customer_department && assignedDepartmentCheck">
                            <v-row dense v-for="(assigned_department ,index) in form.customer_fields.assigned_departments" :key="index" class="mt-4">
                                <v-col cols="12" sm>
                                    <v-autocomplete
                                        :items="departmentList.filter(x => assigned_department.department_id == x.id || !form.customer_fields.assigned_departments.filter(y => y.department_id == x.id).length)"
                                        item-title="name"
                                        item-value="id"
                                        label="انتخاب دپارتمان"
                                        no-data-text="موردی پیدا نشد!"
                                        hide-details
                                        clearable
                                        v-model="assigned_department.department_id"
                                        autocomplete="new-password"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm>
                                    <datetime-input
                                        :max="form.customer_fields.expire_date ? form.customer_fields.expire_date : null"
                                        type="date"
                                        hide-details
                                        label="تاریخ اتمام دسترسی"
                                        clearable
                                        v-model="assigned_department.meta_data.expired_at"
                                    ></datetime-input>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        label="محدودیت تعداد تیکت"
                                        hide-details
                                        v-model="assigned_department.meta_data.limit"
                                        clearable
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn v-tooltip="'حذف دپارتمان'" icon="clear" variant="text" color="error" :disabled="form.customer_fields.assigned_departments.length == 1" @click="form.customer_fields.assigned_departments.splice(index,1)"></v-btn>
                                </v-col>
                            </v-row>
                            <v-btn @click="form.customer_fields.assigned_departments.push({department_id: null,meta_data: {expired_at: null, limit: null}})" :disabled="!!form.customer_fields.assigned_departments.find(x => !x.department_id) || form.customer_fields.assigned_departments.length == departmentList.length" class="rounded d-block mx-auto mt-4" color="secondary" variant="tonal">
                                <v-icon size="18">add</v-icon> افزودن دپارتمان
                            </v-btn>
                        </div>
                        <v-checkbox
                            class="mt-2 pt-0"
                            label="محدود کردن سازمان به محصول/خدمات"
                            hide-details
                            v-if="$system.license.features.customer_department"
                            v-model="assignedServiceCheck"
                            @update:modelValue="!form.customer_fields.assigned_services.length ? form.customer_fields.assigned_services.push({service_id: null, meta_data: {expired_at: null, limit: null}}) : null"
                        ></v-checkbox>
                        <div v-if="$system.license.features.customer_department && assignedServiceCheck">
                            <v-row dense v-for="(assignedService,index) in form.customer_fields.assigned_services" :key="index" class="mt-4">
                                <v-col cols="12" sm>
                                    <v-autocomplete
                                        :items="serviceList.filter(x => assignedService.service_id == x.id || !form.customer_fields.assigned_services.filter(y => y.service_id == x.id).length)"
                                        item-title="name"
                                        item-value="id"
                                        label="انتخاب محصول/خدمات"
                                        no-data-text="موردی پیدا نشد!"
                                        hide-details
                                        clearable
                                        v-model="assignedService.service_id"
                                        autocomplete="new-password"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm>
                                    <datetime-input
                                        :max="form.customer_fields.expire_date ? form.customer_fields.expire_date : null"
                                        type="date"
                                        hide-details
                                        label="تاریخ اتمام دسترسی"
                                        clearable
                                        v-model="assignedService.meta_data.expired_at"
                                    ></datetime-input>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        label="محدودیت تعداد تیکت"
                                        hide-details
                                        v-model="assignedService.meta_data.limit"
                                        clearable
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn v-tooltip="'حذف محصول'" icon="clear" variant="text" color="error" :disabled="form.customer_fields.assigned_services.length == 1" @click="form.customer_fields.assigned_services.splice(index,1)"></v-btn>
                                </v-col>
                            </v-row>
                            <v-btn @click="form.customer_fields.assigned_services.push({service_id: null, meta_data: {expired_at: null, limit: null}})" :disabled="!!form.customer_fields.assigned_services.find(x => !x.service_id) || form.customer_fields.assigned_services.length == serviceList.length" class="rounded d-block mx-auto mt-4" color="secondary" variant="tonal">
                                <v-icon size="18">add</v-icon> افزودن محصول/خدمات
                            </v-btn>
                        </div>
                    </v-form>
                </template>
                <template #title="{title}">
                    <span class="text-meta cursor-pointer font-weight-regular">{{title}}</span>
                </template>
                <template #actions="{step}">
                    <div class="mt-3">
                        <v-btn @click="changeStep(step + 1)" color="success" :loading="loading">{{ step == steps.length ? 'ثبت اطلاعات' : 'ثبت و ادامه'}}</v-btn>
                        <v-btn v-if="step > 1" @click="changeStep(step - 1)" color="error" class="ms-3" variant="text" :disabled="loading">بازگشت</v-btn>
                    </div>
                </template>
            </v-stepper-vertical>
        </v-col>
        <v-dialog persistent v-model="addOrganizationDialog" v-if="$rbac.can('manage organizations')" width="550px">
            <add-organization-from-new-customer @closeAddOrganizationDialog="addOrganizationDialog = false" @success="organizations = $system.organizations;"></add-organization-from-new-customer>
        </v-dialog>
    </div>
</template>
<script>
import { VStepperVertical } from 'vuetify/labs/VStepperVertical'
export default {
    title: "ویرایش",
    components: {
        VStepperVertical,
    },
    data() {
        return {
            loading: false,
            pass1: true,
            pass2: true,
            addOrganizationDialog: false,
            assignedDepartmentCheck: false,
            assignedServiceCheck: false,
            stepper: 1,
            username_type: this.$system.systemSettings.username_type,
            customFieldItems: [],
            form: {
                status: true,
                gender: null,
                first_name: null,
                last_name: null,
                email: null,
                mobile: null,
                password: null,
                password_confirmation: null,
                branch_id: null,
                change_branch: true,
                other_phones: [],
                customer_fields: {
                    expire_date: null,
                    customer_level_id: null,
                    organization_id: null,
                    country_id: null,
                    state_id: null,
                    city_id: null,
                    position: null,
                    supervisor: false,
                    description: null,
                    custom_fields: [],
                    assigned_departments: [],
                    assigned_services: []
                },
            },
            departmentList: [],
            serviceList: [],
            organizations: [],
        };
    },
    computed: {
        maxAssignedExpireDate() {
            let res = null;
            if (this.$system.license.features.customer_department) {
                this.form.customer_fields.assigned_departments.forEach(el => {
                    if(el.meta_data.expired_at && el.meta_data.expired_at > res)
                        res = el.meta_data.expired_at;
                });
                this.form.customer_fields.assigned_services.forEach(el => {
                    if(el.meta_data.expired_at && el.meta_data.expired_at > res)
                        res = el.meta_data.expired_at;
                });
            }
            return res;
        },
        haveCustomField() {
            return this.$system.license.features.customer_custom_field && this.$system.customerCustomFields.length ? 1 : 0;
        },
        steps() {
            return [
                { title: 'اطلاعات هویتی', value: 1 },
                { title: 'اطلاعات تماس', value: 2 },
            ].concat(
                (this.haveCustomField ? [{ title: 'فیلد های سفارشی', value: 3 }] : []),
                [
                    { title: 'تنظیمات امنیتی', value: 3 + this.haveCustomField },
                    { title: 'ویژگی های مشتری', value: 4 + this.haveCustomField },
            ]);
        }
    },
    methods: {
        async changeStep(step) {
            for (let i = 1; i < step; i++)
                if (this.$refs[`step${i}Form`] && !(await this.$refs[`step${i}Form`]?.validate())?.valid)
                    return this.stepper = i;
            if (step <= this.steps.length)
                this.stepper = step;
            else
                this.submit();
        },
        setCustomerLevel(value) {
            if (value != null)
                this.form.customer_fields.customer_level_id = this.organizations.find(x => x.id == value).customer_level_id;
            else this.form.customer_fields.supervisor = false;
        },
        submit() {
            this.loading = true;
            let form = JSON.parse(JSON.stringify(this.form));
            if (!this.$auth.user.full_admin) delete form.branch_id;
            if (this.$system.license.features.customer_department) {
                form.customer_fields.assigned_departments = !this.assignedDepartmentCheck ? [] : form.customer_fields.assigned_departments.filter(x => x.department_id);
                form.customer_fields.assigned_services = !this.assignedServiceCheck ? [] : form.customer_fields.assigned_services.filter(x => x.service_id);
            } else {
                delete form.customer_fields.assigned_departments;
                delete form.customer_fields.assigned_services;
            }
            if (this.haveCustomField)
                form.customer_fields.custom_fields = form.customer_fields.custom_fields.filter(x => x.value !== '' && x.value !== null);
            if (!this.haveCustomField || !form.customer_fields.custom_fields.length)
                delete form.customer_fields.custom_fields;
            if (!form.password) {
                delete form.password;
                delete form.password_confirmation;
            }
            this.$userUpdate(this.$route.query.id, form).then((res) => {
                if (res && res.status == "UPDATED") {
                    this.$toast.success(res.message);
                    this.$router.push({path: '/customers'})
                }
            }).finally(()=>{this.loading = false});
        },
    },
    mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            if (this.$system.license.features.customer_department) {
                this.departmentList = this.$system.departments.filter(x => ![this.$system.customers_department.id, this.$system.managers_department.id].includes(x.id));
                this.serviceList = this.$system.services;
            }
            await this.$system.setStatesCities();
            this.$userGet(this.$route.query.id, 0).then((res) => {
                if (res && res.status == "OK") {
                    let form = { ...res.data };
                    form.customer_fields = JSON.parse(JSON.stringify(form.customer_information));
                    delete form.customer_information;
                    delete form.tags;
                    form.password = null;
                    form.password_confirmation = null;
                    if (this.$system.license.features.customer_department) {
                        form.customer_fields.assigned_departments = JSON.parse(JSON.stringify(form.assigned_departments));
                        form.customer_fields.assigned_services = JSON.parse(JSON.stringify(form.assigned_services));
                        this.assignedDepartmentCheck = !!form.customer_fields.assigned_departments.length;
                        this.assignedServiceCheck = !!form.customer_fields.assigned_services.length;
                        delete form.assigned_departments;
                        delete form.assigned_services;
                    }
                    if (this.haveCustomField) {
                        form.customer_fields.custom_fields = form.custom_fields;
                        delete form.custom_fields;
                    }
                    this.organizations = this.$system.organizations.filter(x => !this.$auth.user.full_admin || x.branch_id == form.branch_id)
                    this.form = form;
                    if (this.haveCustomField)
                        this.customFieldItems = this.$system.customerCustomFields;
                }
            }).finally(()=>{this.$loading.finish()});
        })
    },
};
</script>
